module.exports = __webpack_public_path__ + "static/img/hy-login-icon.6ebad49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/default/hy-login-icon.png
// module id = zNXd
// module chunks = 1